import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import leaf from "../../Assets/Projects/leaf.png"; // <-- Ini gambar untuk SereniTrack
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png"; 
import chatify from "../../Assets/Projects/chatify.png"; 
import suicide from "../../Assets/Projects/suicide.png"; 
import bitsOfCode from "../../Assets/Projects/blog.png"; 

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          {/* Proyek 1: RESTful API */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify} 
              isBlog={false}
              title="RESTful API"
              description="Developed and deployed a RESTful API using Node.js and the Hapi framework, managing deployment on Amazon EC2 (AWS) via SSH. I implemented automated functional (CRUD) testing with Postman to complete the final Bookshelf API project."
              ghLink="https://github.com/ufftz4s/RESTful-API-sederhana" 
            />
          </Col>

          {/* Proyek 2: CkraDana */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode} 
              isBlog={false}
              title="CkraDana"
              description="A comprehensive Financial Management and Education app powered by a robust Laravel (PHP) backend. Responsible for developing the core RESTful API that serves as the backbone, managing all essential features and data transactions for the application."
              ghLink="https://github.com/ufftz4s/CkraDana-Financial-Management-and-Education-app.git" 
            />
          </Col>

          {/* Proyek 3: Fitaja */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor} 
              isBlog={false}
              title="Fitaja"
              description="A Gym Management System application built with Laravel (PHP), designed to manage daily gym operations such as member data and scheduling. It utilizes Vite.js for frontend asset bundling (CSS/JS), ensuring fast loading performance and an efficient interface for administrators."
              ghLink="https://github.com/ufftz4s/FitAja-app.git" 
            />
          </Col>

          {/* --- KARTU INI TELAH DIUBAH --- */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf} 
              isBlog={false}
              title="SereniTrack"
              description="SereniTrack is an innovative, AI-based web application designed to help detect symptoms of depression. It is focused on serving the academic community, providing an early detection tool to promote mental health awareness in the educational environment."
              ghLink="https://github.com/ufftz4s/serenitrack-app.git" // <-- Anda mungkin ingin mengganti link GitHub ini
              // demoLink telah dihapus
            />
          </Col>

          {/* Proyek 5: CareerNes */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide} 
              isBlog={false}
              title="CareerNes"
              description="Kickstart your digital career with CareerNes! We're a one-stop platform connecting you with a variety of online courses and training to enhance your skills."
              figmaLink="https://www.figma.com/design/Rpmq2mrdLQM7PKoFHR84kK/UNNES-CARIER-CENTER?node-id=0-1&t=MRi3LKX1lvxnVbkM-1" 
            />
          </Col>

          {/* Proyek 6: Face Recognition */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Alumni Aplication"
              description="platform built using PHP and MySQL, designed to be a bridge between the university and its graduates. This application provides a centralized portal for alumni to manage their professional data, search for career opportunities."
              ghLink="https://github.com/ufftz4s/Alumni-Cs-app.git"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;